import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { STORAGE_KEYS, StorageService } from '@core/services/storage/storage.service';
import { recentInputActions } from '@store/actions/recent-input.actions';
import { tap } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { recentInputSelectors } from '@store/selectors/recent-input.selectors';

@Injectable()
export class RecentInputEffects {
  addRecentInput$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(recentInputActions.addRecentInput, recentInputActions.removeRecentInput),
        withLatestFrom(this._store.select(recentInputSelectors.all)),
        tap(([, recentInput]) => {
          this._storage.setItem(STORAGE_KEYS.RECENT_INPUT, JSON.stringify(recentInput));
        })
      ),
    {
      dispatch: false,
    }
  );

  constructor(
    private _actions$: Actions,
    private _storage: StorageService,
    private _store: Store<StoreState>
  ) {}
}
